import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LogIn, UserPlus } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import SEO from '../components/SEO';
import Varni2FlyLogo from '../components/Varni2FlyLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const B2BLogin = () => {
  const navigate = useNavigate();
  const [creds, setCreds] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/b2b/login`, creds);
      localStorage.setItem('b2b_token', res.data.token);
      localStorage.setItem('b2b_agent', JSON.stringify(res.data.agent));
      toast.success(`Welcome back, ${res.data.agent.name}!`);
      navigate('/b2b/dashboard');
    } catch (err) {
      const msg = err.response?.data?.detail || 'Login failed';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#2D8DB4]/10 via-white to-[#F7945D]/10 p-4">
      <SEO title="B2B Agent Login - Varni Visa Partner Portal" path="/b2b/login" />
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="text-center pb-3">
          <div className="flex justify-center mb-3">
            <Varni2FlyLogo size="sm" />
          </div>
          <CardTitle className="text-2xl flex items-center justify-center gap-2">
            <LogIn size={22} className="text-[#2D8DB4]" /> B2B Agent Login
          </CardTitle>
          <CardDescription>Access net rate cards & itineraries</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="b2b-login-email" type="email" required value={creds.email} onChange={(e) => setCreds({ ...creds, email: e.target.value })} />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="b2b-login-password" type="password" required value={creds.password} onChange={(e) => setCreds({ ...creds, password: e.target.value })} />
            </div>
            <Button type="submit" data-testid="b2b-login-submit" className="w-full bg-[#2D8DB4] hover:bg-[#247a9a]" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>
          <div className="mt-6 text-center text-sm">
            New to Varni Visa B2B?{' '}
            <Link to="/b2b/register" className="text-[#F7945D] font-semibold hover:underline">
              Register your agency
            </Link>
          </div>
          <div className="mt-3 text-center text-xs text-gray-500">
            <Link to="/" className="hover:underline">← Back to varnivisa.com</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default B2BLogin;
